import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  OperativeBankInfoResponseInterface,
  OperativePortfolioResponseInterface,
  OperativeModelPortfolioResponseInterface,
} from '@techrules/portallib';

/*
enum LocalStorageKey {
  OPERATIVE_PORTFOLIO_CODE = 'OperativePortfolioCode',
}
*/

@Injectable({ providedIn: 'root' })
export class OperativeDataService {
  private _portfolioCode: string = undefined;

  // info del cuestionario
  private _portfolioData =
    new BehaviorSubject<OperativePortfolioResponseInterface>(null);
  portfolioData = this._portfolioData.asObservable();

  // info del banko
  private _bankData = new BehaviorSubject<OperativeBankInfoResponseInterface[]>(
    null
  );
  bankData = this._bankData.asObservable();

  // info del model portfolio
  private _modelPortfolioData =
    new BehaviorSubject<OperativeModelPortfolioResponseInterface>(null);
  modelPortfolioData = this._modelPortfolioData.asObservable();

  // amount
  private _amount = new BehaviorSubject<string>('');
  amount = this._amount.asObservable();

  // operative type
  operativeType = '';

  // verificationId
  verificationId = '';

  constructor() {}
  /*
  // portfolioCode
  get portfolioCode(): string | undefined {
    if (!this._portfolioCode) {
      if (
        window.localStorage &&
        window.localStorage.getItem(LocalStorageKey.OPERATIVE_PORTFOLIO_CODE)
      ) {
        this._portfolioCode = window.localStorage.getItem(
          LocalStorageKey.OPERATIVE_PORTFOLIO_CODE
        );
      } else {
        this._portfolioCode = '';
      }
    }
    return this._portfolioCode;
  }

  set portfolioCode(data: string) {
    window.localStorage.setItem(LocalStorageKey.OPERATIVE_PORTFOLIO_CODE, data);
    this._portfolioCode = data;
  }
*/
  setAmount(value: string) {
    this._amount.next(value);
  }

  setOperativeType(data: string) {
    this.operativeType = data;
  }

  setVerificationId(data: string) {
    this.verificationId = data;
  }

  setPortfolioData(data: OperativePortfolioResponseInterface) {
    this._portfolioData.next(data);
  }

  setBankData(data: OperativeBankInfoResponseInterface[]) {
    this._bankData.next(data);
  }

  setModelPortfolioData(data: OperativeModelPortfolioResponseInterface) {
    this._modelPortfolioData.next(data);
  }
}
